const NewsletterSuccessIcon = ({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      width={100}
      height={100}
      {...props}
    >
      <path
        fill="#61DFFF"
        d="M86.5891 59.1837C86.5891 66.3621 84.4605 73.3793 80.4724 79.3479C76.4843 85.3165 70.8158 89.9684 64.1839 92.7155C57.5519 95.4625 50.2543 96.1813 43.2138 94.7809C36.1734 93.3804 29.7063 89.9237 24.6304 84.8478C19.5546 79.7719 16.0978 73.3049 14.6974 66.2644C13.297 59.224 14.0157 51.9263 16.7628 45.2944C19.5098 38.6624 24.1618 32.994 30.1304 29.0059C36.099 25.0178 43.1162 22.8892 50.2946 22.8892C59.9205 22.8892 69.1521 26.713 75.9587 33.5196C82.7652 40.3261 86.5891 49.5578 86.5891 59.1837Z"
      />
      <path
        fill="#61DFFF"
        d="M41.6523 73.6026L60.3694 94.0587C67.6854 91.9415 74.1504 87.5774 78.8498 81.584C83.5493 75.5906 86.2452 68.2712 86.5562 60.6613L60.4716 45.8071L41.6523 73.6026Z"
      />
      <path
        fill="#231F20"
        d="M63.8585 53.9837L47.8718 69.6624C47.6869 69.8438 47.4672 69.9878 47.2255 70.086C46.9838 70.1842 46.7248 70.2348 46.4631 70.2348C46.2015 70.2348 45.9425 70.1842 45.7008 70.086C45.4591 69.9878 45.2394 69.8438 45.0545 69.6624L36.138 60.8706C35.7651 60.5043 35.5557 60.0078 35.5557 59.4902C35.5557 58.9725 35.7651 58.476 36.138 58.1097L39.1259 55.1791C39.4982 54.8139 40.0028 54.6081 40.5293 54.6067C41.0559 54.6054 41.5616 54.8085 41.9358 55.1718L46.4974 59.4786L46.5111 59.492L58.0557 48.335C58.429 47.9703 58.9344 47.7656 59.4612 47.7656C59.9881 47.7656 60.4935 47.9703 60.8668 48.335L63.8547 51.2118C64.0413 51.3932 64.1895 51.6089 64.2907 51.8466C64.3919 52.0844 64.4442 52.3394 64.4445 52.597C64.4449 52.8546 64.3933 53.1098 64.2927 53.3478C64.1921 53.5857 64.0445 53.8019 63.8585 53.9837Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61DFFF"
        d="M95.0796 85.792C94.075 85.792 93.0929 86.0914 92.2575 86.6522C91.4222 87.2131 90.7711 88.0102 90.3867 88.9429C90.0022 89.8755 89.9016 90.9015 90.0976 91.8916C90.2936 92.8817 90.7774 93.7911 91.4878 94.5049C92.1982 95.2187 93.1033 95.7048 94.0887 95.9018C95.074 96.0987 96.0953 95.9977 97.0235 95.6114C97.9517 95.2251 98.745 94.5709 99.3032 93.7315C99.8614 92.8922 100.159 91.9053 100.159 90.8959C100.159 89.5422 99.6241 88.244 98.6715 87.2869C97.7189 86.3297 96.4268 85.792 95.0796 85.792Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61DFFF"
        d="M2.53984 55.1455C2.03751 55.1455 1.54644 55.2952 1.12877 55.5756C0.711101 55.856 0.38553 56.2546 0.193297 56.7209C0.00106471 57.1872 -0.0491839 57.7003 0.0488155 58.1953C0.146815 58.6904 0.38871 59.1451 0.74391 59.502C1.09911 59.8589 1.55157 60.1019 2.04425 60.2004C2.53692 60.2989 3.04761 60.2483 3.5117 60.0552C3.97579 59.862 4.37248 59.5349 4.65156 59.1153C4.93064 58.6956 5.07964 58.2022 5.07964 57.6975C5.07964 57.0206 4.81198 56.3715 4.33567 55.8929C3.85936 55.4144 3.21344 55.1455 2.53984 55.1455Z"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61DFFF"
        d="M70.8676 4C69.9447 4 69.0424 4.27498 68.2751 4.79019C67.5077 5.3054 66.9096 6.03768 66.5564 6.89444C66.2032 7.7512 66.1108 8.69396 66.2908 9.6035C66.4709 10.513 66.9153 11.3485 67.568 12.0042C68.2206 12.66 69.052 13.1065 69.9572 13.2874C70.8624 13.4684 71.8007 13.3755 72.6534 13.0206C73.5061 12.6657 74.2349 12.0648 74.7477 11.2937C75.2604 10.5227 75.5341 9.61612 75.5341 8.68877C75.5341 7.44522 75.0424 6.25263 74.1673 5.37331C73.2922 4.494 72.1052 4 70.8676 4Z"
      />
    </svg>
  )
}

export default NewsletterSuccessIcon
